import { render, staticRenderFns } from "./ReportCardComponent.vue?vue&type=template&id=60818b56&scoped=true&"
import script from "./ReportCardComponent.vue?vue&type=script&lang=js&"
export * from "./ReportCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportCardComponent.vue?vue&type=style&index=0&id=60818b56&prod&lang=css&"
import style1 from "./ReportCardComponent.vue?vue&type=style&index=1&id=60818b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60818b56",
  null
  
)

export default component.exports